import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseURL } from "../../BaseUrl";

//fucntion to retrive the token from the local storage
const getToken = () => localStorage.getItem("workManagement")
// API headers including token
const getAuthHeaders = () => ({
   headers:{
    Authorization:`Bearer ${getToken()}`
   }
})
export const getDashboardData = createAsyncThunk(
    "dashboard/getDashboardData",
    async ({dept_id,company_id}) => {
        // console.log("dept_id==>",deptID)
        try {
            const response = await baseURL.get(`/tracking/dash-board-progress-deptID?dept_id=${dept_id}&company_id=${company_id}`,getAuthHeaders());
            // console.log("response===>",response.data)
            return response.data.data
        }catch (error){
            throw error;
        }

    }
);
export const dashboardSlice = createSlice({
    name:"dashboard",
    initialState:{
        dashboardData:[],
        loading:false,
        error:null,
    },
    reducers:{},
    extraReducers:(builder)=>{
        builder
        .addCase(getDashboardData.pending,(state)=>{
            state.loading= false
        })
        .addCase(getDashboardData.fulfilled,(state,action)=>{
            state.loading=false
            state.dashboardData=action.payload
        })
        .addCase(getDashboardData.rejected,(state,action)=>{
            state.loading=false
            state.error=action.error
        })
    }
})
export const getdashboardData = (state) => state.dashboard.dashboardData
export default dashboardSlice.reducer